module.exports = __webpack_public_path__ + "static/media/93.32b5d49f.jpg";